<template>
  <div class="dashboard">
    <SwappingSquaresSpinner v-if="this.$store.getters.isLoading"
      :animation-duration="1000"
      :size="90"
      :color="this.$store.getters.config.palette.primary"
      style="margin: auto; position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);"
    />
    <!--    <va-button @click="sendRequestStatus(11, 'blo', 'dashboard')">Socket Patato</va-button>-->
    <!--    <dashboard-charts />-->
    <dashboard-info-block v-if="!this.$store.getters.isLoading" />
  </div>
</template>

<script>
// import DashboardCharts from './DashboardCharts'
import DashboardInfoBlock from './DashboardInfoBlock'
import { SwappingSquaresSpinner } from 'epic-spinners'
// import { HttpTransportType } from '@aspnet/signalr'
// import DashboardTable from './DashboardTable'

export default {
  name: 'dashboard',
  components: {
    // DashboardCharts,
    DashboardInfoBlock,
    SwappingSquaresSpinner,
  },
  data () {
    return {
      clients: [],
      dashboardError: undefined,
      intervalId: null,
    }
  },
  methods: {
    addAddressToMap ({ city, country }) {
      this.$refs.dashboardMap.addAddress({ city: city.text, country })
    },
    async initClients (clients) {
      this.clients = []
      clients.forEach(item => {
        let color = 'gray'
        let text = 'Parked'
        if (item.status === 'request') {
          color = 'warning'
          text = 'Requested'
        } else if (item.status === 'onthego') {
          color = 'info'
          text = 'Pick up'
        } else if (item.status === 'awaiting') {
          color = 'success'
          text = 'Awaiting'
        } else if (item.status === 'completed') {
          color = 'dark'
          text = 'Completed'
        }
        item.text = text
        item.color = color
        item.icon = ''
        this.clients.splice(this.clients.length, 0, item)
      })
      this.$store.commit('setLoading', false)
    },
    removeClient (clientId) {
      let theIndex
      this.clients.filter((item, index) => {
        if (item.clientId === clientId) {
          theIndex = index
        }
      })
      this.clients.splice(theIndex, 1)
    },
    async sendRequestStatus (identifier, status, scope) {
      // await this.$socket.invoke('ProgressUpdate', identifier, status, scope, this.$store.getters.localUser.email, 'dashboard', this.$store.getters.namespace)
    },
  },
  created () {
  },
  mounted () {
    // this.$options.sockets['sendToAdminOf' + this.$store.getters.namespace] = function (data) {
    //   if (data.type === 'new') {
    //     this.addNewClient(data.message)
    //     return
    //   }
    //   this.clients.filter(function (item) {
    //     if (item.clientId === data.clientId) {
    //       item.status = data.message
    //     }
    //   })
    // }
    this.intervalId = setInterval(() => {
      this.$store.dispatch('checkIsActive')
        .catch(error => this.errorHandler(error.response, true))
    }, 10000)
  },
  beforeDestroy () {
    clearInterval(this.intervalId)
  },
}
</script>

<style lang="scss">
  .row-equal .flex {
    .va-card {
      height: 100%;
    }
  }

  .dashboard {
    .va-card {
      margin-bottom: 0 !important;
    }
  }
</style>
